import {
  localMarketSuggestions,
  type MarketSearchSelection,
} from "./marketSearchSelections";

const normalize = (value: string) =>
  value.trim().toLowerCase().replace(/\s+/g, " ");
// These describe several drinks categories, even though our menu only lists them for cider.
const ambiguousStyleNames = new Set(["dry", "medium", "sweet", "still"]);
const containerAliases = {
  keg: "keg",
  kegs: "keg",
  cask: "cask",
  casks: "cask",
  can: "can",
  cans: "can",
  bottle: "bottle",
  bottles: "bottle",
  bag: "bag",
  bags: "bag",
  pouch: "pouch",
  pouches: "pouch",
  "bag in box": "bagInBox",
  "jerry can": "jerryCan",
  "jerry cans": "jerryCan",
  box: "box",
  boxes: "box",
} as const;
const containerKeywords = Object.entries(containerAliases).sort(
  ([left], [right]) => right.length - left.length,
);

export const parseMarketFilterQuery = (
  search: string,
): Extract<MarketSearchSelection, { kind: "filterQuery" }> | undefined => {
  const query = normalize(search.replaceAll(",", " "));
  for (const [keyword, containerType] of containerKeywords) {
    const containerPattern = new RegExp(`(^| )${keyword}(?= |$)`);
    if (!containerPattern.test(query)) {
      continue;
    }
    const style = normalize(
      query.replace(containerPattern, " ").replace(/\bin\b/g, " "),
    );
    if (ambiguousStyleNames.has(style)) {
      continue;
    }
    const matches = localMarketSuggestions.filter(
      (selection) =>
        (selection.kind === "style" || selection.kind === "category") &&
        (normalize(selection.label) === style ||
          normalize(selection.value.split(" & ")[0] ?? "") === style),
    );
    const selection = matches.length === 1 ? matches[0] : undefined;
    if (
      !selection ||
      (selection.kind !== "style" && selection.kind !== "category")
    ) {
      continue;
    }
    const container = localMarketSuggestions.find(
      (option) => option.kind === "container" && option.value === containerType,
    );
    return {
      kind: "filterQuery",
      categoryKey: selection.categoryKey,
      styleSearchValues: selection.kind === "style" ? [selection.value] : [],
      containerType,
      label: `${selection.label}, ${container?.label ?? containerType}`,
    };
  }
};
